export const getMessageDraftStorageKey = (conversationId: string) => `gc-chat-${conversationId}`;
